<template>
	<div class="list-page">
		
		<!-- 列表 -->
		<section class="page-ctn w1200">
			<div class="page-main">
				<!-- 面包屑 -->
				<div class="bread-crumbs">
					<span>您现在的位置是：</span><a href="javascript:;" @click="goUrl({name:'pageIndex'})">首页</a> > <p>{{newsListInfo.catename}}</p>
				</div>
				
				<div class="list-cont clearfix">
					<!-- 主栏 -->
					<div class="list-main">
						<!-- 文章列表 -->
						<ul class="article-list" v-if="newsListInfo.list && newsListInfo.tid==1">
							<li v-for="item in newsListInfo.list.list" :key="item.id" @click="goUrl({ name:'pageDetail', params:{ id:item.id}})">
								<div class="date">
									<span class="day">{{item.inputtime.substring(8,10)}}</span>
									<span class="year-month">{{item.inputtime.substring(5,7)}}月<br>{{item.inputtime.substring(0,4)}}</span>
								</div>
								<div class="info">
									<h4>{{item.title}}</h4>
									<p>{{item.description}}</p>
									<span class="btn">查看详情</span>
								</div>
							</li>
						</ul>
						
						<!-- 视频列表 -->
						<ul class="video-list" v-if="newsListInfo.list && newsListInfo.tid==3">
							<li v-for="(item,index) in newsListInfo.list.list" :key="item.id">
								<div class="zan-box">
									<div class="zan" :class="{act:item.is_like==1}" @click="clickLike(item,index)">{{item.like?item.like:0}}</div>
								</div>
								<div class="img" :style="'background-image:url('+ item.thumb +');'" @click="goUrl({ name:'pageDetail', params:{ id:item.id}})"></div>
								<div class="info" @click="goUrl({ name:'pageDetail', params:{ id:item.id}})">
									<h4>{{item.title}}</h4>
									<p>所属分部：{{newsListInfo.catename}}</p>
									<p>学生名称：{{item.student_name}}</p>
									<p>发布时间：{{item.inputtime}}</p>
								</div>
							</li>
						</ul>
						
						<div class="paging" v-if="newsListInfo.list">
							<span class="prev" :class="{show:pageNum>1}" v-if="pageNum>1" @click="changeList(pageNum-1)">上一页</span>
							<span class="num" :class="{act:item==pageNum}" v-for="(item,index) in pagingList" :key="index" @click="changeList(item)">{{item}}</span>
							<span class="next" :class="{show:pageNum < pageLen}" v-if="pageNum<pageLen" @click="changeList(pageNum+1)">下一页</span>
							<p>共{{newsListInfo.list.total}}条</p>
						</div>
					</div>
				</div>
				
			</div>
		</section>
	</div>
</template>

<script>
import pageMixin from '@/mixins/page.js'
export default {
	mixins: [pageMixin],
	name: 'pageIndex',
	data () {
		return {
			catid:'',
			newsListInfo:{},
			pageNum:1,
			pageSize:10,
			pageLen:0,	//总页数
		}
	},
	
	computed:{
		pagingList(){
			var pagList = []
			for(var i=0; i<this.pageLen; i++){
				pagList.push(i+1)
			}
			return pagList
		}
	},
	
	created(){
		this.catid = this.$route.params.catid
		this.getListInfo()
	},

	
	//防止
	beforeRouteUpdate (to, from, next) {
		this.catid = to.params.catid?to.params.catid:''
		this.getListInfo()
		next() // 一定要有next
	},
  
	methods:{
		//获取列表
		getListInfo(){
			if(this.listLoading){return}
			this.listLoading = true
			this.$axios({
				url:'/index.php?s=common&c=api&m=getNewList',
				params:{
					catid	: this.catid,
					page	: this.pageNum,
					limit	: this.pageSize
				},
				success:(res)=>{
					this.newsListInfo = res.data
					this.pageLen = Math.ceil(res.data.list.total/this.pageSize)
				},
				complete:()=>{
					this.listLoading = false
				}
			})
		},
		//切换分页
		changeList(num){
			if(num<=0){return}
			if(num>this.pageLen){return}
			this.pageNum = num
			this.getListInfo()
		},
		
		//点赞
		clickLike(item,index){
			if(item.is_like==1){	//已点过赞
				return
			}
			this.$axios({
				url:'/index.php?s=common&c=api&m=like',
				params:{
					newId:item.id,	//顶级栏目id
				},
				success:(res)=>{
					this.newsListInfo.list.list[index].is_like = 1
					this.newsListInfo.list.list[index].like += 1
				}
			})
		}
		
	}
}
</script>

<style lang="less" scoped>
.list-page{ background:#F8FAFC; padding-top:0;}
.list-cont{
	padding-bottom:50px;
	.list-side{
		width:360px; float:right; margin-left:30px;
		.side-item{
			padding:10px 0 30px;
			h3{font-size:20px; line-height:20px; color:#1E2533; margin-bottom:20px; }
			.list{
				background: #FFFFFF; box-shadow: 0px 5px 30px 0px rgba(2, 15, 70, 0.08); box-sizing: border-box; padding:20px 30px;
				li{
					font-size:16px; color:#637584; line-height: 40px; cursor: pointer; display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; 
					&:hover{color:#2A82EF; text-decoration: underline;}
				}
			}
		}
	
	}
	.list-main{
		overflow:hidden; background: #FFFFFF; box-shadow: 0px 5px 30px 0px rgba(2, 15, 70, 0.08); padding:20px 40px;
		.video-list{
			// display:flex; justify-content: space-between; flex-wrap:wrap;
			li{ 
				overflow:hidden; padding:15px 100px 15px 0; border-bottom:1px solid #CCCCCC; position:relative;
				.zan-box{ 
					display:flex; justify-content: center; align-items: center; width:100px; height:100%; position:absolute; right:0; top:0; 
					.zan{
						width:40px; font-size:12px; color:#999999; text-align:center; padding-top:30px; line-height: 16px; cursor: pointer;
						 background:url(../../assets/img/ico-zan.png) no-repeat top center; background-size:24px 24px;
						 &.act{ background-image:url(../../assets/img/ico-zan2.png)}
					}
				}
				.img{ width:202px; height:120px; background-size:cover; background-color:#ccc; cursor: pointer; float:left; margin-right:20px; }
				.info{
					overflow:hidden;   cursor: pointer; 
					h4{ display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; font-size:20px; font-weight: bold; color:#1E2533; line-height:40px; margin-bottom:8px; }
					p{font-size:14px; color:#999999; line-height:24px; display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden;}
					&:hover h4{color:#BF2323;}
				}
			}
		}
		
		.article-list{
			// display:flex; justify-content: space-between; flex-wrap:wrap;
			li{ 
				 overflow:hidden;  cursor: pointer; padding:15px 0; border-bottom:1px solid #CCCCCC; 
				.date{
					float:left; width:164px; color:#637584; display:flex; align-items: center; height:80x;
					.day{ display:inline-block; font-size:50px; line-height:80px; }
					.day::after{content:'/'; display:inline-block; line-height:70px; font-size:26px; margin:0 4px; vertical-align: top; color:#637584; }
					.year-month{ display:inline-block; font-size:22px; line-height:40px; text-align: right;}
		
				}
				.info{
					overflow:hidden;
					h4{display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; font-size:20px; color:#1E2533; line-height:40px; margin-bottom:8px; }
					p{ max-height:40px; font-size:14px; color:#999999; line-height:20px; display: block; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 2; }
					.btn{ display:inline-block; font-size:12px; color:#D41F10; line-height:20px; margin-top:10px; font-weight: bold;}
				}
				
			}
			li:hover{
				.info h4{color:#D41F10;}
			}
		}
		
	
		.paging{
			padding:40px 0; text-align:center ;
			p{margin-left:10px; font-size:20px; color:#999999; line-height:40px; display:inline-block;  vertical-align: top;}
			span{
				height:40px; width:40px; display:inline-block; box-sizing: border-box; border:1px solid #F0F0F0; display:inline-flex; align-items: center; justify-content: center; font-size:16px; color:#999999; margin:0 5px; cursor: pointer;
				&.prev,
				&.next{ width:70px; }
				&:hover,
				&.act{background:#BF2323; color:#fff; border-color:#BF2323;}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue